import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  documentUploadStarted: false,
  documentUploadWorking: false,
  documentUploadCompleted: false,
  documentUploadErrors: [],
  applicationData: {},
  applicationNumber: '',
};

export const applySlice = createSlice({
  name: 'apply',
  initialState: INITIAL_STATE,
  // Reducers describe operations on state. Under the hood, reducers take the
  // current state and modify it in some manner then return the modified state.
  // Redux stores the modified state as the current state.  Subsequent reducers
  // will then operate on the modified state - thus, state changes accumulate/persist
  reducers: {
    updatePermitApplicationData: (state, action) => {
      state.applicationData = {
        ...state.applicationData,
        ...action.payload,
      };
    },
    removeRegistrantData: (state) => {
      delete state.applicationData.registrant;
    },
    removeContactsData: (state) => {
      delete state.applicationData.contacts;
    },
    removePropertyDetailsData: (state) => {
      delete state.applicationData.propertyDetails;
    },
    removeListingsData: (state) => {
      delete state.applicationData.listings;
    },
    setApplyApplicationNumber: (state, action) => {
      state.applicationNumber = action.payload;
    },
    setDocumentUploadStarted: (state, action) => {
      state.documentUploadErrors = [];
      state.documentUploadWorking = false;
      state.documentUploadCompleted = false;
      state.documentUploadStarted = action.payload;
    },
    setDocumentUploadWorking: (state, action) => {
      state.documentUploadStarted = false;
      state.documentUploadCompleted = false;
      state.documentUploadWorking = action.payload;
    },
    setDocumentUploadCompleted: (state, action) => {
      state.documentUploadStarted = false;
      state.documentUploadWorking = false;
      state.documentUploadCompleted = action.payload;
    },
    setDocumentUploadError: (state, action) => {
      state.documentUploadErrors = [
        ...state.documentUploadErrors,
        action.payload,
      ];
    },
    clearDocumentUploadError: (state) => {
      state.documentUploadErrors = [];
    },
    resetDocumentUploadProgressStatus: (state) => {
      state.documentUploadStarted = false;
      state.documentUploadWorking = false;
      state.documentUploadCompleted = false;
    },
    resetApplyState: (state) => INITIAL_STATE,
  },
});

export const {
  updatePermitApplicationData,
  removeRegistrantData,
  removeContactsData,
  removeListingsData,
  removePropertyDetailsData,
  setApplyApplicationNumber,
  setDocumentUploadStarted,
  setDocumentUploadWorking,
  setDocumentUploadCompleted,
  setDocumentUploadError,
  clearDocumentUploadError,
  resetDocumentUploadProgressStatus,
  resetApplyState,
} = applySlice.actions;

export default applySlice.reducer;
